import { makeStyles } from '@material-ui/styles'
import moment from 'moment'
import type { ServiceCertInfo } from 'api-client/resmgr.model'
import Badge, { type BadgeVariant } from 'core/elements/badge/Badge'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal/Modal'
import Text from 'core/elements/Text'
import type Theme from 'core/themes/model'
import { type CertificateExpiryStatus, getCertificateExpiryStatus } from './helper'

const expiryBadgeVariant: Record<CertificateExpiryStatus, BadgeVariant> = {
  healthy: 'success',
  warning: 'warning',
  expired: 'error',
}

const expiryBadgeText: Record<CertificateExpiryStatus, string> = {
  healthy: 'Valid',
  warning: 'Expiring Soon',
  expired: 'Expired',
}

const useStyles = makeStyles((theme: Theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: theme.spacing(1.5),
    alignItems: 'center',
  },
}))

interface Props {
  open: boolean
  onClose: () => void
  // Read-only display; this component does not fetch or mutate certificate data.
  certInfo: ServiceCertInfo
}

// PCD-9693: read-only certificate details, shown from the Image Service's per-host status cell
// on the Service Health Dashboard (Service Health tab and Host Health tab).
const GlanceCertificateInfoModal = ({ open, onClose, certInfo }: Props) => {
  const classes = useStyles({})
  const status = getCertificateExpiryStatus(certInfo?.expiry_date)

  return (
    <Modal
      title="Image Library Certificate"
      open={open}
      onClose={onClose}
      panel="dialog"
      maxWidth={500}
      footer={<Button onClick={onClose}>Close</Button>}
    >
      <div className={classes.grid}>
        <Text variant="caption1">Status</Text>
        <Badge variant={expiryBadgeVariant[status]} text={expiryBadgeText[status]} />

        <Text variant="caption1">Certificate Path</Text>
        <Text variant="body2">{certInfo?.cert_path}</Text>

        <Text variant="caption1">Issued</Text>
        <Text variant="body2">{moment.unix(certInfo?.start_date).format('MMM D, YYYY')}</Text>

        <Text variant="caption1">Expires</Text>
        <Text variant="body2">{moment.unix(certInfo?.expiry_date).format('MMM D, YYYY')}</Text>
      </div>
    </Modal>
  )
}

export default GlanceCertificateInfoModal
